module.exports = __webpack_public_path__ + "img/7.6eb16c8b.webp";